import _ from "lodash";
import ReactTooltip from "react-tooltip";
import styled from "styled-components";

import { formatterDateTime } from "~/utils/formatterDateTime";

type IssuerProps = {
  shortLabel?: string;
  longLabel: string;
  name: string;
  issuedDate: Date | string | null | undefined;
  logo: string;
};

const ResultContainer = styled.div`
  display: inline-flex;
  align-items: center;
  column-gap: 6px;
  font-size: 9px;
  font-weight: 800;
  border: 1px solid #787878;
  border-radius: 20px;
  padding: 4px 10px;
  margin-top: 7px;
  cursor: default;
  &:hover {
    background-color: #eaeaea;
  }
`;

const HorizontalSeparator = styled.div<{ isHighAlert?: boolean }>`
  border-left: 1px solid #d3d3d3;
  height: 17px;
  ${(params) => params.isHighAlert && `border-color: #FF3A26;`}
`;

const OpaqueTooltip = styled(ReactTooltip).attrs(() => ({
  place: "bottom",
  effect: "solid",
  border: true,
  borderColor: "lightgray",
  backgroundColor: "#FFF",
  textColor: "#000",
  offset: { right: "3px" },
}))`
  opacity: 1 !important;
  padding-left: 13px !important;
`;

const TooltipContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1px;
  max-width: 300px;
  font-size: 11px;
`;

const TooltipTitle = styled.div`
  font-size: 16px;
  font-weight: 800;
  text-transform: uppercase;
`;

const TooltipSubtitle = styled.div`
  font-size: 11px;
  font-weight: 700;
`;

const TooltipFooterText = styled.div<{ isHighAlert?: boolean }>`
  font-size: 12px;
  font-weight: 800;
  margin-top: 4px;
  ${(params) => params.isHighAlert && `color: #FF3A26;`}
`;

export default function Issuer({ shortLabel, longLabel, name: issuer, issuedDate, logo }: IssuerProps) {
  let issuedDateText = "-";
  if (issuedDate && typeof issuedDate === "object") issuedDateText = formatterDateTime.format(issuedDate);
  else if (typeof issuedDate === "string") issuedDateText = formatterDateTime.format(new Date(issuedDate));

  const id = _.uniqueId();
  return (
    <>
      <ResultContainer data-tip data-for={id}>
        <img src={logo} />
        <HorizontalSeparator />
        <span>{shortLabel}</span>
      </ResultContainer>
      <OpaqueTooltip id={id}>
        <TooltipContentContainer>
          <TooltipTitle>{issuer}</TooltipTitle>
          <TooltipSubtitle>{`Last updated:`}</TooltipSubtitle>
          <div>{issuedDateText}</div>
          <TooltipFooterText>{longLabel}</TooltipFooterText>
        </TooltipContentContainer>
      </OpaqueTooltip>
    </>
  );
}
